<template>
  <ul
    ref="navigation"
    :class="[$style.navigation, { [$style.closed]: !isOpen }]"
    :style="style"
  >
    <li>
      <a
        href="https://sp.i-voce.jp/special/shindan/"
        class="g-subtitle3"
        :class="$style.link"
        >診断</a
      >
    </li>
    <li>
      <a
        href="https://i-voce.jp/special/beauty-ingredients/"
        class="g-subtitle3"
        :class="$style.link"
        >美容成分一覧</a
      >
    </li>
    <li>
      <a
        href="https://i-voce.jp/make-up/"
        class="g-subtitle3"
        :class="$style.link"
        >メイクアップ</a
      >
    </li>
    <li>
      <a
        href="https://i-voce.jp/skincare/"
        class="g-subtitle3"
        :class="$style.link"
        >スキンケア</a
      >
    </li>
    <li>
      <a
        href="https://i-voce.jp/ranking/"
        class="g-subtitle3"
        :class="$style.link"
        >ランキング</a
      >
    </li>
    <li>
      <a
        href="https://i-voce.jp/fortune/"
        class="g-subtitle3"
        :class="$style.link"
        >占い</a
      >
    </li>
    <li>
      <a
        href="https://i-voce.jp/tags/manga/"
        class="g-subtitle3"
        :class="$style.link"
        >マンガ</a
      >
    </li>
    <li>
      <a
        href="https://i-voce.jp/serial-stories/"
        class="g-subtitle3"
        :class="$style.link"
        >連載・シリーズ</a
      >
    </li>
    <li>
      <a
        href="https://i-voce.jp/presents/"
        class="g-subtitle3"
        :class="$style.link"
        >プレゼント</a
      >
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      isOpen: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      return {
        justifyContent: "flex-start",
        visibility: "hidden",
        width: 0,
      };
    },
    computed: {
      style() {
        return {
          justifyContent: this.justifyContent,
          visibility: this.visibility,
        };
      },
    },
    mounted() {
      for (let i = 0; i < this.$refs.navigation.children.length; i++) {
        this.width += this.$refs.navigation.children[i].clientWidth;
      }

      this.adjustLayout();

      window.addEventListener("resize", this.adjustLayout);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.adjustLayout);
    },
    methods: {
      adjustLayout() {
        if (window.innerWidth > this.width) {
          this.justifyContent = "center";
        } else {
          this.justifyContent = "flex-start";
        }
        this.visibility = "visible";
      },
    },
  };
</script>

<style module>
  .navigation {
    display: flex;
    align-items: center;
    height: 32px;
    overflow-x: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    transition: height 0.15s ease;
  }
  .navigation::-webkit-scrollbar {
    display: none;
  }
  .navigation li {
    padding: 0 10px;
    flex: 0 0 auto;
  }
  .navigation li:first-child {
    margin-left: 8px;
  }
  .navigation li:last-child {
    margin-right: 8px;
  }
  .link {
    color: rgba(17, 17, 17, 0.54);
  }

  .closed {
    height: 0;
  }
</style>
